// extracted by mini-css-extract-plugin
export default {"container":"oE-z","innerContainer":"pE-z","multipleLines":"qE-z","heading":"rE-z","content":"sE-z","linkColor":"tE-z"};